var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44.057 38.95c1.798-2.364 3.78-1.788 5.528.267C56.183 46.974 63.192 62 63.192 62H28c-.091.286 2.325-8.25 5.157-11.34 1.97-2.151 5.886-3.725 5.886-3.725s3.38-5.84 5.014-7.986zm-15.17-22.704c1.481 3.126-.709 6.416-.064 12.061 0 0 1.3 6.344 1.976 9.732l.041.208 7.859 5.337c-.365.61-.684 1.148-.924 1.557l-.098.167-18.418-12.509c2.762 6.12 5.078 11.597 5.205 13.33.308 6.166.383 9.117.572 15.854-.181.009-4.36.164-5.146-4.419-.825-4.807-1.377-8.357-1.986-11.971l-4.162-7.88-10.706 23.74c-.484-.283-3.655-2.316-2.268-6.456.275-.82 6.874-20.677 8.826-26.544 0 0 3.328 1.063 4.927 1.539.234.07.404.033.45-.056l.01-.042-9.215-6.259c-.778 1.109-1.323 1.904-1.323 1.904-1.152-1.627-1.353-3.407-.36-5.12.793-1.37 2.911-5.728 4.845-7.021 1.116-.735 1.473-.822 2.338-1.046 2.966-.703 6.302-1.467 8.28-1.534 4.254-.144 8.599 3.862 9.34 5.428zm-4.296 6.792a352.442 352.442 0 0 0-4.093 7.028l-.474.835 6.585 4.472c-.589-1.934-1.482-5.522-1.66-6.464-.2-1.312-.36-3.977-.358-5.871zm-13.586-6.153c-.523.273-2.331 2.683-3.918 4.89l-.163.228 4.125 2.802c.931-2.042 2.348-5.101 3.91-7.768-1.444-.244-3.329-.476-3.954-.152zm20.723-14.7c2.535 1.505 3.156 4.044 1.38 7.032-1.559 2.625-4.147 3.552-6.75 2.006-2.601-1.546-3.155-4.044-1.466-6.887 1.602-2.697 4.166-3.738 6.836-2.152z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadwork);
export default __webpack_public_path__ + "static/media/roadwork.a7e9599c346c0bf47de84639592e83ce.svg";
export { ForwardRef as ReactComponent };